<div class="main">
  <div class="inputs">
    <spb-new-case-id-list/>
    <spb-new-case-id-list [org]="true"/>
  </div>
  <button matButton="filled" (click)="start()" [disabled]="invalid()">Starta</button>
  <button matButton="outlined"
          style="margin-left: 20px"
          [disabled]="searchIgDisabled()"
          (click)="search()">Sök Intressegemenskap
  </button>
</div>
